@if (currentOrder && routeDays()) {
  <div class="actions-footer-bar__route-days">  
    <ci-chip-set 
      overflow
      (change)="handleChipSetRouteDayChange($event)"
      [attr.data-from-header-planner]="fromHeaderPlanner()"
      >
      @for(day of routeDays(); track day.id; let i = $index) {
        <ci-filter-chip-outline
          class="route-days__chip"
          [chip]="day"
          [attr.icon-name]="day.iconName"
          [selected]="day.id - 1 === dayToShowIndex"
          [disabled]="day.id > currentOrder"
        >
          <span slot="label">{{'Día' | translate}} {{day.id}}</span>
        </ci-filter-chip-outline>
      }
    </ci-chip-set>
  </div>
}